export default {
    loading: {
        module: true
    },
    params: {
        year_month_from : null,
        year_month_up : null,
        vouchertype_id: null,
        branchoffice_id: null
    },
    paramsVoucherType:{
        paginate : false,
        filter : null,
        branchoffice : null,
        branchoffice_id : null,
    },
    data_report:[],
    voucherTypes:[],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/accounting-detail/state.js